import BasePermissionsMixin from '@/app/shared/mixins/BasePermissionsMixin';

export default {
    mixins: [
        BasePermissionsMixin,
    ],
    computed: {
        enableLayerSwitcher() {
            return this.checkTool('layerswitcher');
        },
        enableStreetView() {
            return this.checkTool('streetview');
        },
        enableBackoffice() {
            return this.checkTool('backoffice');
        },
        enableScaleLine() {
            return this.checkTool('scaleline');
        },
        enableScaleBox() {
            return this.checkTool('scalebox');
        },
        enableMousePosition() {
            return this.checkTool('mouseposition');
        },
        // enableDashboard() {
        //     return this.checkTool('dashboard');
        // },
        enablePrintVisible() {
            return this.checkTool('print_visible_emissions');
        },
        enableIdentify() {
            return this.checkTool('identify');
        },
        enableCatalog() {
            return this.checkTool('catalog');
        },
        enableMapLayers() {
            return this.checkTool('layers');
        },
        enableRegulations() {
            return this.checkTool('regulations');
        },
        enableAnnotations() {
            return this.checkTool('annotations');
        },
        enableMeasure() {
            return this.checkTool('measure');
        },
        enableLinks() {
            return this.checkTool('links');
        },
        enableAttribution() {
            return this.checkTool('attribution');
        },
        enableSchoolDistance() {
            return this.checkTool('schooldistance');
        },
        enableTooltip() {
            return this.checkTool('tooltip');
        },
        userCanChangeData() {
            if(this.checkPermission(this.acl, 'allowAllChanges')
                || this.checkPermission(this.acl, 'allowChangeChannel')
                || this.checkPermission(this.acl, 'allowChangePriority')
                || this.checkPermission(this.acl, 'allowChangeState')
                || this.checkPermission(this.acl, 'allowChangeVisibility')
                || this.checkPermission(this.acl, 'allowChangeType')
                || this.checkPermission(this.acl, 'allowChangeSubType')
                || this.checkPermission(this.acl, 'allowChangeAddress')
                || this.checkPermission(this.acl, 'allowChangePointReference')
                || this.checkPermission(this.acl, 'allowAddNote')
                || this.checkPermission(this.acl, 'allowLoadPhotos')
                || this.checkPermission(this.acl, 'allowAssignUnity')
                || this.checkPermission(this.acl, 'allowGenerateEdocLink')
                || this.checkPermission(this.acl, 'allowNotifyUserUnits')
                || this.checkPermission(this.acl, 'allowAssignUser'))
            {
                return true;
            }

            return false;
        },
        enableExpandCollapse() {
            return this.checkTool('expandcollapse');
        },
        enableAddSideBarLeft() {
            return this.enableMapLayers || (detectMobile() && (this.enableFilterStatus || this.enableFilterType));
        },
        activeExpandCollapse() {
            return this.enableExpandCollapse && this.mapButtons.expandcollapse.active;
        },
        initialCollapsedExpandCollapse() {
            return this.enableExpandCollapse && (this.mapButtons.expandcollapse.active != undefined ? this.mapButtons.expandcollapse.active : false ) && this.mapButtons.expandcollapse.collapsed;
        },
    },
    methods: {
    },
};